import React, { useContext, useEffect, useState } from "react";
import { BillingContext } from "../../store/billing.store";

import BottomBanner from "../../../../components/BottomBanner/BottomBanner";
import "rc-slider/assets/index.css";
import "./CustomizePlanModal.css";
import AddMoreCredits from "./common/AddMoreCredits/AddMoreCredits";
import Summary from "./common/Summary/Summary";
import { calculateExtraCreditsPrice } from "../../../../services/utils/calculatePrice";
export default function CustomizePlanModal({
  setToggle,
  selectedPlan,
  subscriptionType,
  selectPlanToPurchase,
  error,
  organizationCredits,
  addCreditsToggle,
  setAddCreditsToggle,
  setSubscriptionType,
  onUserSelect,
  minSeats,
  isVersion2,
}) {
  const [planToPurchase, setPlanToPurchase] = useState(selectedPlan);
  const { state, dispatch } = useContext(BillingContext);
  const [classToggle, setClassToggle] = useState("");
  const [creditsToAdd, setCreditsToAdd] = useState({
    phoneCredits: { numberOfCredits: 0, index: 0, price: 0 },
    personalEmailCredits: { numberOfCredits: 0, index: 0, price: 0 },
    exportCredits: { numberOfCredits: 0, index: 0, price: 0 },
  });
  useEffect(() => {
    let organizationSubscriptionPeriod =
      organizationCredits.plan.numberOfMonths == 12 ? "yearly" : "monthly";
    if (
      organizationSubscriptionPeriod !== subscriptionType ||
      selectedPlan.planId == "0"
    )
      return setCreditsToAdd({
        phoneCredits: { numberOfCredits: 0, index: 0, price: 0 },
        personalEmailCredits: { numberOfCredits: 0, index: 0, price: 0 },
        exportCredits: { numberOfCredits: 0, index: 0, price: 0 },
      });
    let currentCreditsToAdd = { ...creditsToAdd };
    ["phoneCredits", "personalEmailCredits", "exportCredits"].forEach(
      (creditType) => {
        let allExtraCredits = calculateExtraCreditsPrice({
          creditType: creditType,
          isAnnual: subscriptionType == "yearly",
        }).extraCredits;
        let orgExtraCredits = organizationCredits.plan[creditType];
        let index = 0;

        for (let i in allExtraCredits) {
          if (allExtraCredits[i].amount == orgExtraCredits.extra) index = i;
        }
        currentCreditsToAdd[creditType].numberOfCredits = orgExtraCredits.extra;
        currentCreditsToAdd[creditType].price =
          calculateExtraCreditsPrice({
            creditType: creditType,
            isAnnual: subscriptionType == "yearly",
            amount: orgExtraCredits.extra,
          }).amount || 0;
        currentCreditsToAdd[creditType].index = parseInt(index);
      }
    );
    setCreditsToAdd(currentCreditsToAdd);
  }, [subscriptionType]);
  useEffect(() => {
    if (addCreditsToggle.active) {
      setClassToggle("show-credit-section");
      if (addCreditsToggle.firstIndex) {
        let currentCreditsToAdd = { ...creditsToAdd };
        let allExtraCredits = calculateExtraCreditsPrice({
          creditType: addCreditsToggle.type,
          isAnnual: subscriptionType == "yearly",
        }).extraCredits;
        currentCreditsToAdd[addCreditsToggle.type].index = 1;
        currentCreditsToAdd[addCreditsToggle.type].price =
          allExtraCredits[1].price;
        currentCreditsToAdd[addCreditsToggle.type].numberOfCredits =
          allExtraCredits[1].amount;
        setCreditsToAdd(currentCreditsToAdd);
      }
    } else {
      setClassToggle("");
    }
  }, [addCreditsToggle]);

  useEffect(() => {
    if (selectedPlan) {
      setPlanToPurchase({
        ...selectedPlan,
        yearly: subscriptionType == "yearly",
      });
    }
  }, [subscriptionType, selectedPlan]);

  const handleAddCredits = (type) => {
    setAddCreditsToggle({ type, active: true });
  };
  const handleSelectPlanWithAddons = () => {
    const creditsState = { ...creditsToAdd };
    const extraCredits = [];
    for (let creditType in creditsState) {
      extraCredits.push({
        amount: creditsState[creditType].numberOfCredits,
        creditType,
      });
    }
    const currentPlan = {
      ...planToPurchase,
      extraCredits: extraCredits.length ? extraCredits : null,
    };
    selectPlanToPurchase(currentPlan);
  };
  const handleSelectUsers = (users) => {
    setPlanToPurchase({ ...planToPurchase, numberOfSeats: users });
    onUserSelect(users, planToPurchase.planId);
  };
  return (
    <BottomBanner
      toggle={!!selectedPlan}
      onClose={() => {
        setToggle(false);
        setAddCreditsToggle({ ...addCreditsToggle, active: false });
      }}
    >
      <div id={"customize-plan"}>
        {isVersion2 && (
          <AddMoreCredits
            addCreditsToggle={addCreditsToggle}
            handleAddCredits={handleAddCredits}
            classToggle={classToggle}
            onAddCredits={setCreditsToAdd}
            creditsToAdd={creditsToAdd}
            selectedPlan={planToPurchase}
            /* planCredits={
              organizationCredits.plan &&
              organizationCredits.plan[addCreditsToggle.type]
            }*/
            organizationCreditPlan={organizationCredits.plan}
            subscriptionType={subscriptionType}
            plan={planToPurchase}
          />
        )}
        <Summary
          setAddCreditsToggle={setAddCreditsToggle}
          addCreditsToggle={addCreditsToggle}
          selectedPlan={planToPurchase}
          onYearlySwitch={setSubscriptionType}
          onSelectPlan={handleSelectPlanWithAddons}
          creditsToAdd={creditsToAdd}
          onUserSelect={handleSelectUsers}
          addOnsPrice={
            creditsToAdd["phoneCredits"].price +
            creditsToAdd["personalEmailCredits"].price +
            creditsToAdd["exportCredits"].price
          }
          minSeats={minSeats}
          isVersion2={isVersion2}
        />
      </div>
    </BottomBanner>
  );
}
